<template  >
    <div
        class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-4 px-lg-3 px-4 px-lg-0 my-3 my-lg-0">
        <div
            class="col-12 col-lg-6 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden">
            <div class="col-12 d-flex justify-content-center text-start align-items-center flex-wrap w-75 mt-1">
                <span class="font- fuente-posm label-1 d-flex flex-wrap fuentes-clamp3">La clave está en el remarketing
                    <span></span>
                    <span class="font- label-2  fuente-nova mt-1 ps-3 w-100 fuentes-clamp4">Ahora es tu momento de activar la publicidad más rentable: la basada en tus propios clientes.

<br><br>
Recupera clientes que no han venido en mucho tiempo enviándoles mensajes de WhatsApp directamente.
<br><br>
Descarga una base de datos para uso en meta ads y google ads

                    </span>
                </span>
            </div>
        </div>
        <div
            class="col-12 col-lg-6 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden mt-lg-5">
            <div class="col-12 d-flex justify-content-center text-start align-items-center flex-wrap px-lg-4">
                <div
                    class="spaceMedia col-lg-9 col-12 position-relative d-flex justify-content-center align-items-center align-content-center">
                    <img :src="a65" class="img-fluid w-75">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'page10',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a1: require('@/assets/images/a1.png'),
            a65: require('@/assets/images/a54.webp')
        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        }
    },
}
</script>
<style lang="css" scoped>
.cubeSpace {
    overflow: hidden;
    height: auto;
    width: 100vw;
    height: 100vh;
}

.label-1 {
    color: var(--color-2);
    font-size: 70px;
    line-height: 1.1;
    max-width: 950px;
    word-wrap: break-word;
}

.label-2 {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.1;
}

@media (max-width: 992px) and (min-width: 768px) {
    .label-1 {
        font-size: 60px;
    }

    .label-2 {
        font-size: 27px;
    }
}

@media (max-width: 767px) and (min-width: 0) {
    .label-1 {
        font-size: 28px;
    }

    .label-2 {
        font-size: 19px;
    }
}
</style>